import { render, staticRenderFns } from "./PopoverPatientOptions.vue?vue&type=template&id=483378ec&scoped=true"
import script from "./PopoverPatientOptions.vue?vue&type=script&lang=js"
export * from "./PopoverPatientOptions.vue?vue&type=script&lang=js"
import style0 from "./PopoverPatientOptions.vue?vue&type=style&index=0&id=483378ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483378ec",
  null
  
)

export default component.exports